import { render, staticRenderFns } from "./CourseGroupDetailCard.vue?vue&type=template&id=5d0fab12&scoped=true&"
import script from "./CourseGroupDetailCard.vue?vue&type=script&lang=js&"
export * from "./CourseGroupDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseGroupDetailCard.vue?vue&type=style&index=0&id=5d0fab12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0fab12",
  null
  
)

export default component.exports